import { Award, ChevronRight, ClipboardCheck, type LucideIcon } from 'lucide-react';

/** Bandeau de rappel (charte) : pastille indigo, texte, flèche ; action secondaire facultative à droite. */
function Reminder({
  icon: Icon,
  title,
  desc,
  cta,
  onOpen,
  aside,
}: {
  icon: LucideIcon;
  title: string;
  desc: string;
  cta: string;
  onOpen: () => void;
  aside?: React.ReactNode;
}) {
  return (
    <div className="flex items-center gap-1 rounded-row border border-primary-100 bg-surface-indigo pr-2">
      <button type="button" onClick={onOpen} className="flex min-w-0 flex-1 items-center gap-3 rounded-row px-4 py-3 text-left transition-colors hover:bg-primary-50">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-panel-indigo text-white">
          <Icon size={18} aria-hidden />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block text-sm font-semibold text-heading">{title}</span>
          <span className="block text-xs leading-relaxed text-secondary">{desc}</span>
        </span>
        <span className="hidden shrink-0 items-center gap-0.5 text-sm font-semibold text-primary-600 sm:flex">
          {cta}
          <ChevronRight size={16} aria-hidden />
        </span>
        <ChevronRight size={18} className="shrink-0 text-primary sm:hidden" aria-hidden />
      </button>
      {aside}
    </div>
  );
}

export function EvaluationReminder({ onOpen }: { onOpen: () => void }) {
  return (
    <Reminder
      icon={ClipboardCheck}
      title="Votre évaluation de départ vous attend"
      desc="Quelques minutes pour aider votre auto-école à personnaliser votre formation."
      cta="Commencer"
      onOpen={onOpen}
    />
  );
}

export function LicenceReminder({ onOpen, onSnooze }: { onOpen: () => void; onSnooze: () => void }) {
  return (
    <Reminder
      icon={Award}
      title="Félicitations pour votre permis !"
      desc="Déposez les pièces pour la fabrication de votre permis et donnez-nous votre avis."
      cta="Voir"
      onOpen={onOpen}
      aside={
        <button
          type="button"
          onClick={onSnooze}
          className="shrink-0 rounded-pill px-3 py-1.5 text-xs font-medium text-secondary transition-colors hover:bg-primary-50"
        >
          Plus tard
        </button>
      }
    />
  );
}
